// ──────────────────────────────────────────────────────────────
// 도서관 강좌 "참여 가능한 유효 프로그램" 필터 — 단일 진실 공급원
//
// 사용자 지적(2026-06-15): "긁는 게 다가 아니라, 참여 가능한 유효 프로그램인지가 핵심."
// 도서관 게시판에는 휴관·채용·상호대차·희망도서 같은 비참여 공지가 섞여 있어,
// 강좌·체험·행사 등 실제 신청·참여 가능한 항목만 남긴다.
//
// 화면(App.js culturalRaw)과 회귀 테스트(scripts/test-libProgram.js)가 같은 규칙을 공유.
// (2026-06-18 모듈화 5단계)
// ──────────────────────────────────────────────────────────────

// 비참여 공지(노이즈) — 하나라도 걸리면 제외. 공고·행정·채용 전역 제외 상시지시(2026-07-05)로 키워드 보강.
const LIB_NOISE = /휴관|휴실|휴무|점검|서버|정전|단수|희망도서|상호대차|연체|반납|분실|채용|기간제|공무직|위촉|입찰|낙찰|계약|위탁|용역|당첨|선정\s*결과|결과\s*발표|결과\s*공고|개인정보|정보공개|운영\s*시간|시간\s*변경|일정\s*변경|이용\s*안내|회원\s*가입|비치|장서\s*점검|정리\s*기간|소독|방역|설문|만족도|이전\s*안내|폐관|폐쇄|공고$|모집\s*결과|과태료|통계|규정\s*개정|지침|고시|공시\s*송달|당직\s*의료|제증명|발급\s*안내|사칭|보도\s*자료|의견\s*수렴/;

// 참여 가능한 프로그램 신호 — 하나라도 있으면 통과
const LIB_PROG = /강좌|교실|강의|특강|아카데미|클래스|클럽|체험|프로그램|캠프|워크숍|워크샵|수강생|만들기|공예|코딩|로봇|북\s*콘서트|작가\s*와|작가\s*초청|강연|세미나|동아리|인형극|마술쇼|과학교실|독서교실|글쓰기|낭독|독후|전시회|전시|공연|음악회|콘서트|상영회|영화\s*상영|축제|페스티벌|페스타|행사|이벤트|대회|공모전|참가자\s*모집|수강\s*신청/;

// 제목 t가 "참여 가능한 실제 프로그램"인가?
// - 너무 짧거나(3자 미만) 노이즈에 걸리면 false
// - 노이즈 아니면서 프로그램 신호가 있으면 true
function isLibProgram(t) {
  t = String(t || "").trim();
  if (t.length < 3 || LIB_NOISE.test(t)) return false;
  return LIB_PROG.test(t);
}

// 공고·행정·채용 비참여 판별 (2026-07-05 사장님 상시지시) — 보건소·행사 등 전역 방어용.
// 백엔드 _isNonParticipatory와 규칙 동일: 참여 신호 있으면 유지(false), 없고 관리 신호만이면 제외(true).
const PARTICIP = /교실|강좌|강습|강의|특강|교육생|수강생|참여자\s*모집|참가자\s*모집|프로그램|체험|캠프|아카데미|클래스|공연|전시|축제|영화|상영|콘서트|공모전|백일장|낭독|독서|걷기|챌린지|건강교실|수업|클럽|동아리|워크숍|워크샵|한마당|나눔|무료\s*교육|교육\s*신청|수강\s*신청|인문학|글쓰기|만들기|공예|코딩|로봇/;
const ADMIN = /채용|기간제|공무직|위촉|입찰|낙찰|계약|위탁|용역|회의록|보도\s*자료|행정\s*예고|입법\s*예고|고시|공시\s*송달|과태료|통계|규정\s*개정|지침|매뉴얼|휴진|휴무|부재|시간\s*변경|일정\s*변경|운영\s*중단|폐기|반송|당직\s*의료|선거|투표|세금|소득세|결과\s*공고|선정\s*결과|모집\s*결과|의견\s*수렴|설문|만족도|폐쇄|중단\s*안내|주차장|공사\s*안내|홈페이지\s*(점검|개편|이용)|사칭|개인정보|정보공개|누리집|이전\s*안내|제증명|발급\s*안내|방역|소독|정전|단수|카드뉴스|주의정보|예방뉴스|소식지|안전검사\s*결과|검사\s*결과\s*알림|회수(대상)?식품|위해식품|긴급회수|알림방|가능\s*의료기관\s*안내/;
function isNonParticipatory(t) {
  t = String(t || "");
  if (PARTICIP.test(t)) return false;
  return ADMIN.test(t);
}

module.exports = { isLibProgram, isNonParticipatory, LIB_NOISE, LIB_PROG };
